class Carousel {
  constructor(config, elementClass) {
    this.config = config;
    this.elementClass = elementClass;
    this.swiper = null;
  }

  initSwiper() {
    if (this.config.mobileOnly) {
      let resizeTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          this.handleResize();
        }, 250);
      });
    }

    if (this.config.mobileOnly) {
      if (window.innerWidth <= 749) {
        this.swiper = new Swiper(this.elementClass, this.config);
      } else {
        return;
      }
    }

    this.swiper = new Swiper(this.elementClass, this.config);
  }

  getSwiperInstance() {
    return this.swiper;
  }

  handleResize() {
    if (window.innerWidth <= 749) {
      this.initSwiper();
    } else {
      this.destroySwiper();
    }
  }

  destroySwiper() {
    if (this.swiper !== null) {
      this.swiper.destroy(true, true);
    }
  }
}
